import React from 'react';
import { Toaster } from 'react-hot-toast';
import AppRouter from './AppRouter';
import { SettingsProvider } from './contexts/SettingsProvider';
import './styles/main.sass';
import RootComponent from './RootComponent';

function App() {
  return (
    <SettingsProvider>
      <Toaster containerStyle={{ zIndex: 99999 }} />
      <RootComponent />
      {/* <AppRouter /> */}
    </SettingsProvider>
  );
}

export default App;